import { render, staticRenderFns } from "./editPassword.vue?vue&type=template&id=452e0cbb&scoped=true"
import script from "./editPassword.vue?vue&type=script&lang=js"
export * from "./editPassword.vue?vue&type=script&lang=js"
import style0 from "./editPassword.vue?vue&type=style&index=0&id=452e0cbb&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452e0cbb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('452e0cbb')) {
      api.createRecord('452e0cbb', component.options)
    } else {
      api.reload('452e0cbb', component.options)
    }
    module.hot.accept("./editPassword.vue?vue&type=template&id=452e0cbb&scoped=true", function () {
      api.rerender('452e0cbb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/accountManage/components/editPassword.vue"
export default component.exports